module.exports = __webpack_public_path__ + "static/media/cross.b1b92a4f.svg";